import React, { useState } from 'react';
import { FiSearch, FiChevronRight } from "react-icons/fi";
import PracticeSubjectSidebar from './PracticeSubjectSidebar';

const PracticeSubjectView = ({
    subjectsFromApi,
    selectedSubject,
    setSelectedSubject,
    topics,
    loadingTopics,
    searchValue,
    onSearchChange,
    onTopicClick,
}) => {

    const [isSubjectMenuOpen, setIsSubjectMenuOpen] = useState(false);

    return (
        <div className="animate-in slide-in-from-right-4 duration-500">
            <div className="w-full h-[74px] flex items-center justify-center mb-8">
                <span className="text-[28px] font-[500] text-[#333333]">
                    Select Your Test
                </span>
            </div>

            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
                <h3 className="text-[18px] font-[500] text-[#333333]">
                    All Subjects
                </h3>

                <div className="relative w-full max-w-[475px]">
                    <input
                        type="text"
                        placeholder="Search for Courses, test, or Study Material..."
                        value={searchValue}
                        onChange={onSearchChange}
                        className="w-full h-[40px] pl-4 pr-10 rounded border"
                    />
                    <FiSearch className="absolute right-3 top-1/2 -translate-y-1/2" />
                </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-8 mb-16">

                <PracticeSubjectSidebar
                    subjects={subjectsFromApi}
                    selectedSubject={selectedSubject}
                    setSelectedSubject={setSelectedSubject}
                    isSubjectMenuOpen={isSubjectMenuOpen}
                    setIsSubjectMenuOpen={setIsSubjectMenuOpen}
                />

                <div className="flex-1">
                    {loadingTopics ? (
                        <div className="text-center py-12 text-gray-500">
                            Loading topics...
                        </div>
                    ) : topics.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-[24px]">
                            {topics.map((topic) => (
                                <div
                                    key={topic._id}
                                    onClick={() => onTopicClick(topic)}
                                    className="bg-[#88C0FF] rounded-[6px] p-4 flex justify-between cursor-pointer hover:shadow-md"
                                >
                                    <div>
                                        <h3 className="text-[18px] font-[500]">
                                            {topic.paperName}
                                        </h3>
                                        <p className="text-[16px] text-[#00000099] mt-4">
                                            {topic.totalQuestions || 0} Practice Questions
                                        </p>
                                    </div>

                                    <div className="w-[40px] h-[40px] bg-[#21C11E] rounded-full flex items-center justify-center text-white">
                                        <FiChevronRight size={22} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-12 text-gray-500">
                            No topics available for this subject yet.
                            <br />
                            Coming soon...
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PracticeSubjectView;